import React, { useEffect, useState } from "react";
import useMessagingConfig from "../../custom-hook/useMessagingConfig";

const ConfirmSMSModal = ({ contact, isBulk = false, onConfirm, onCancel, messageType = "" }) => {
  const { config, loading: configLoading, error, updateConfig } = useMessagingConfig();
  const [body, setBody] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!config) return;

    const isSurvey = messageType === "survey";
    const defaultMessage = isSurvey
      ? "Please participate in our short survey by clicking the link below:"
      : "Thanks for your visit. Please share your feedback by clicking the link below:";

    const message = isSurvey
      ? config.survey_message || defaultMessage
      : config.feedback_message || defaultMessage;

    setBody(message);
  }, [config, messageType]);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    const isSurvey = messageType === "survey";

    const payload = isSurvey
      ? { survey_message: body }
      : { feedback_message: body };

    const result = await updateConfig(payload);
    setIsSubmitting(false);

    if (result.success) {
      onConfirm({ body }); // send final message
    } else {
      console.error("Failed to update config:", result.error);
      alert("Failed to update the message. Please try again.");
    }
  };

  if (configLoading || error) return null;

  const isSurvey = messageType === "survey";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center backdrop-blur-md z-50 p-4">
      <div className="bg-white rounded-md shadow-md w-full max-w-lg p-8">
        <h3 className="text-xl font-semibold mb-4">
          Confirm {isSurvey ? "Survey" : "Feedback"} SMS
        </h3>

        <div className="mb-6">
          {isBulk ? (
            <p className="text-gray-600 text-sm">
              Are you sure you want to send a {isSurvey ? "survey" : "feedback"} SMS to the selected contacts?
            </p>
          ) : (
            <p className="text-gray-600 text-sm">
              Are you sure you want to send a {isSurvey ? "survey" : "feedback"} SMS to{" "}
              <span className="font-medium">{contact?.name}</span> at{" "}
              <span className="font-medium">{contact?.phone_number}</span>?
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm text-gray-500 mb-1">Message</label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={6}
            className="w-full border-b text-sm py-2 outline-none placeholder:text-gray-400 resize-none"
            placeholder={`Write your ${isSurvey ? "survey" : "feedback"} message...`}
          />
        </div>

        <div className="flex justify-end mt-8 gap-4">
          <button
            onClick={onCancel}
            className="bg-gray-200 text-gray-800 px-6 py-3 rounded-md hover:bg-gray-300 shadow-sm transition-all"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isSubmitting}
            className={`px-6 py-3 rounded-md shadow-md transition-all text-white ${
              isSubmitting ? "bg-[#001E2B]/70 cursor-not-allowed" : "bg-[#001E2B] hover:bg-opacity-90"
            }`}
          >
            {isSubmitting ? "Sending..." : `Send ${isSurvey ? "Survey" : "Feedback"} SMS`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSMSModal;
